import Component from '../Component';
import React from 'react';
import ReactDOM from 'react-dom';
import {Checkbox} from 'reactis-forms';
import immutable from 'immutable';
import Sortable from '../Sortable';
import _ from 'underscore';
import uuid from 'uuid';
import classNames from 'classnames';
import {ModalWindow} from 'reactis-modal';

export default class ImageGallery extends Component {

	static contextTypes = {
		store: React.PropTypes.object,
	};

	constructor(props) {
		super(props);
		this.uid = uuid.v4();
		this.state = {
			busy: false,
			overed: false,
			files: []
		}
	}

	componentDidMount() {
		this.uploader = new plupload.Uploader({
			runtimes : 'html5,html4',
			multi_selection: true,
			unique_names: true,
			drop_element: this.uid + "_dropzone",
			browse_button : this.uid + '_pickfiles',
			url : '/upload/image?height=100&width=0',
			filters : {
				max_file_size : '100mb',
				mime_types: [
					{ title : "Image files", extensions : "jpg,gif,png"}
				]
			},
			init: {
				FilesAdded: (up, files) => {
					plupload.each(files, (file) => {
						this.handleFileAdd(file);
					});
					this.startUpload();
				},

				FileUploaded: this.handleFileUploaded.bind(this),
				UploadProgress: this.handleUploadProgress.bind(this),
				UploadComplete: this.handleUploadComplete.bind(this),

				Error: function(up, err) {
					alert(err.message);
				},

				init:() => {
					this.uploaderInited = true;
					if (this.uploaderDestroyed) {
						this.uploader.destroy();
					}
				}
			}
		});
		this.uploader.init();
	}

	componentWillUnmount() {
		if (this.uploaderInited) {
			this.uploader.destroy();
		}
		else {
			this.uploaderDestroyed = true;
		}
	}

	startUpload() {
		this.setState({busy: true});
		this.uploader.start();
	}

	handleFileAdd(file) {
		this.state.files = [];
		this.state.files.push(file);
		this.forceUpdate();
	}

	handleUploadProgress(up, file) {
		this.forceUpdate();
	}

	handleFileUploaded(up, file, response) {
		response = JSON.parse(response.response);

		const o = {th: response.th, file: response.file, orig: response.orig};
		o.id = -Math.random();
		const newValue = this.props.value ? this.props.value.push(immutable.fromJS(o)) : immutable.fromJS([o]);
		this.props.onChange(newValue);
	}

	showImagePicker() {
		const win = new ModalWindow('Vyberte obrázek', <ImageList popup={true} onSelect={(row) => {this.handleSelectImage(row)}} onClose={() => win.hide()} />);
		win.className = 'widemodal';
		win.show(this.context.store.dispatch);
	}

	zoomImage(e, img) {
		window.hs.expand(e.target, { src: img});
	}

	handleSelectImage(row) {
		const item = immutable.fromJS({id: row.id, th: row.th, orig: row.orig});
		const value = this.props.value ? this.props.value.push(item) : immutable.List([item]);
		if (this.props.onChange) {
			this.props.onChange(value);
		}
		if (this.props.onBlur) {
			this.props.onBlur(value);
		}
	}

	updateImage(index, image) {
		const update = immutable.fromJS(image);
		const value = this.props.value.set(index, update);
		if (this.props.onChange) {
			this.props.onChange(value);
		}
		if (this.props.onBlur) {
			this.props.onBlur(value);
		}
	}

	showImageEditor(index, image) {
		const win = new ModalWindow('Ořízněte obrázek', <ImageEditor popup={true}
																	 image={image}
																	 onSave={(image) => {win.hide(); this.updateImage(index, image)}}
																	 onClose={() => win.hide()} />);
		win.className = 'widemodal';
		win.show(this.context.store.dispatch);
	}



	handleUploadComplete(up, files) {
		this.setState({busy: false});
	}

	handleClick(e) {
		e.nativeEvent.stopImmediatePropagation();
	}

	handleReset() {
		if (this.props.onChange) {
			this.props.onChange(null);
		}
		if (this.props.onBlur) {
			this.props.onBlur(null);
		}
	}

	dragEnter(e){
		this.setState({overed:true});
	}

	dragLeave(e){
		this.setState({overed:false});
	}

	handleSort(data) {
		const v = this.props.value.toJS();
		const newArr = data.map((id) => {
			return _.findWhere(v, {id: id});
		});
		if (this.props.onChange) {
			this.props.onChange(immutable.fromJS(newArr));
		}
	}

	handleRemove(id) {
		if (this.props.onChange) {
			this.props.onChange(this.props.value.filter((item) => item.get('id') != id));
		}
	}

	render() {
		let items = [];
		if (this.props.value) {
			items = this.props.value.map((item, index) => {
				let it = item.toJS();
				return (
					<div key={it.id} id={it.id} style={{position:'relative'}}>
						<span className="remove icon-cross3" onClick={() => this.handleRemove(it.id)}></span>
						<img src={it.th.url}
							 style={{cursor: 'url(/assets/js/plugins/highslide/graphics/zoomin.cur), auto'}}
							 onClick={(e) => this.zoomImage(e, it.orig)}
							 width={it.th.width}
							 height={it.th.height}
						/>
					</div>
				)
			});
		}

		return (
			<div>
				<div className="image-gallery">
					<Sortable onSort={(data) => this.handleSort(data)}>
						{items}
					</Sortable>
				</div>
				<div style={{clear:'both'}}>
					<div id={this.uid + '_dropzone'}
						 onDragEnter={(e) => this.dragEnter(e)}
						 onDrop={(e) => this.dragLeave(e)}
						 onDragLeave={(e) => this.dragLeave(e)}>
						<div id={this.uid + '_pickfiles'} className={classNames('btn btn-default dropzone', {'overed': this.state.overed})}>
							<div style={{pointerEvents: 'none'}}>
								Vybrat obrázky z disku
							</div>
							<div style={{pointerEvents: 'none', fontSize:10, textAlign:'center'}}>nebo přetáhněte soubor sem</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/Form/ImageGallery.js